import React, { useState } from 'react';
import AccountantSidebar from './components/AccountantSidebar';
import Header from '../teacher_screen/components/Header';
import {
    Search,
    Filter,
    MoreHorizontal,
    User,
    ChevronRight,
    ArrowUpRight,
    Download,
    Mail,
    Phone,
    CreditCard,
    Plus
} from 'lucide-react';

export default function AccountantStudents() {
    const students = [
        { id: 'STU001', name: 'Rohit Sharma', class: 'Grade 10-A', parent: 'Sanjay Sharma', contact: '+91 98765 43210', dues: '₹12,000', plan: 'Quarterly' },
        { id: 'STU002', name: 'Sanya Mirza', class: 'Grade 8-B', parent: 'Imran Mirza', contact: '+91 87654 32109', dues: '₹0', plan: 'Annual' },
        { id: 'STU003', name: 'Virat Kohli', class: 'Grade 11-A', parent: 'Prem Kohli', contact: '+91 76543 21098', dues: '₹55,000', plan: 'Monthly' },
        { id: 'STU004', name: 'PV Sindhu', class: 'Grade 9-C', parent: 'P.V. Ramana', contact: '+91 65432 10987', dues: '₹0', plan: 'Annual' },
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <AccountantSidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Student Accounts"
                    subtitle="Manage student financial profiles and fee subscription plans"
                >
                    <button className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm hover:bg-gray-50 uppercase tracking-tight">
                        <Download size={18} className="text-gray-400" />
                        Export Ledger
                    </button>
                    <button className="flex items-center gap-3 py-2.5 px-6 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">
                        <Plus size={18} />
                        Subscription
                    </button>
                </Header>

                <div className="max-w-7xl mx-auto">
                    {/* Search Bar Refined */}
                    <div className="bg-white p-8 rounded-[32px] border border-gray-100 shadow-sm mb-8 flex flex-col md:flex-row items-center justify-between gap-6">
                        <div className="relative flex-1 w-full group">
                            <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-blue-500 transition-colors" size={18} />
                            <input
                                type="text"
                                placeholder="UID, Name or Class..."
                                className="w-full h-11 pl-11 pr-4 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-100 transition-all font-sans"
                            />
                        </div>
                        <div className="flex items-center gap-3">
                            <button className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm hover:bg-gray-50 uppercase tracking-tight">
                                <Filter size={18} className="text-gray-400" />
                                Filter
                            </button>
                        </div>
                    </div>

                    {/* Table Section */}
                    <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden flex flex-col mb-10">
                        <div className="p-8 flex items-center justify-between border-b border-gray-50">
                            <div className="flex items-center gap-6">
                                <h3 className="text-[20px] font-black text-[#111827]">Financial Records</h3>
                                <div className="flex items-center gap-2">
                                    <span className="w-2.5 h-2.5 bg-blue-500 rounded-full animate-pulse"></span>
                                    <span className="text-gray-400 font-bold text-[14px]">{students.length} Student Profiles</span>
                                </div>
                            </div>
                            <button className="p-1.5 text-gray-400 hover:text-gray-900"><MoreHorizontal size={22} /></button>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="w-full text-left">
                                <thead className="bg-[#F8FAFC]">
                                    <tr>
                                        <th className="px-8 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase">Info</th>
                                        <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Class</th>
                                        <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase">Guardian Details</th>
                                        <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-center">Strategy</th>
                                        <th className="px-6 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-right">Due Amount</th>
                                        <th className="px-8 py-5 text-[11px] font-black text-gray-400 tracking-widest uppercase text-right">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {students.map((stu) => (
                                        <tr key={stu.id} className="border-b border-gray-50 last:border-0 hover:bg-slate-50 transition-all group">
                                            <td className="px-8 py-5">
                                                <div className="flex items-center gap-4">
                                                    <div className="w-11 h-11 rounded-xl bg-blue-50 text-blue-500 flex items-center justify-center font-black group-hover:scale-105 transition-transform overflow-hidden italic text-xs uppercase">
                                                        {stu.name.split(' ').map(n => n[0]).join('')}
                                                    </div>
                                                    <div>
                                                        <p className="text-[15px] font-black text-[#111827] mb-0.5">{stu.name}</p>
                                                        <p className="text-[12px] font-bold text-gray-400 uppercase tracking-tighter">UID: {stu.id}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-5 text-center">
                                                <span className="px-3 py-1 bg-slate-50 border border-gray-100 rounded-lg text-[13px] font-black text-gray-600">{stu.class}</span>
                                            </td>
                                            <td className="px-6 py-5">
                                                <p className="text-[14px] font-bold text-[#111827]">{stu.parent}</p>
                                                <div className="flex items-center gap-1.5 mt-0.5 text-blue-500">
                                                    <Phone size={12} />
                                                    <span className="text-[11px] font-bold tracking-widest">{stu.contact}</span>
                                                </div>
                                            </td>
                                            <td className="px-6 py-5 text-center">
                                                <span className="text-[12px] font-bold text-gray-500 uppercase tracking-widest bg-gray-50 px-3 py-1.5 rounded-lg border border-gray-100">
                                                    {stu.plan}
                                                </span>
                                            </td>
                                            <td className="px-6 py-5 text-right">
                                                <p className={`text-[17px] font-black tracking-tighter ${stu.dues === '₹0' ? 'text-gray-300' : 'text-rose-500'}`}>
                                                    {stu.dues}
                                                </p>
                                            </td>
                                            <td className="px-8 py-5 text-right">
                                                <div className="flex items-center justify-end gap-1">
                                                    <button className="p-2 text-gray-400 hover:text-emerald-500 hover:bg-emerald-50 rounded-xl transition-all" title="Record Payment">
                                                        <Plus size={16} />
                                                    </button>
                                                    <button className="p-2 text-gray-400 hover:text-amber-500 hover:bg-amber-50 rounded-xl transition-all" title="Send Reminder">
                                                        <Mail size={16} />
                                                    </button>
                                                    <button className="p-2 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-xl transition-all" title="View History">
                                                        <ArrowUpRight size={16} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
